export default __webpack_public_path__ + "static/media/annex6.1b834de3.png";